import wechat from '@/api/wechat';

import { WECHAT_GRANT, WECHAT_JSSDK, FETCH_WECHAT_USER, FETCH_WECHAT_TRAINER } from './types';

export default {
    [WECHAT_GRANT]({ commit }, payload) {
        return wechat.grant(payload.code)
            .then((resp) => {
                commit(WECHAT_GRANT, resp);
            });
    },
    [WECHAT_JSSDK]({ commit }, payload) {
        return wechat
            .jssdk(payload.url)
            .then((resp) => {
                commit(WECHAT_JSSDK, resp);
            });
    },
    [FETCH_WECHAT_USER]({ commit }) {
        return wechat
            .getUser()
            .then(resp => commit(FETCH_WECHAT_USER, resp));
    },
    [FETCH_WECHAT_TRAINER]({ commit }) {
        return wechat
            .getTrainer()
            .then(resp => commit(FETCH_WECHAT_TRAINER, resp));
    },
};



// WEBPACK FOOTER //
// ./src/store/wechat/actions.js